<div class="d-flex flex-column ws-flex-auto min-height-0">
    <ws-bread-crumbs [breadcrumbs]="breadcrumbs" currentPageTitle="Invoices"></ws-bread-crumbs>
    <div class="ws-section">
        <div class="ws-section__header">
            <h4 class="ws-section__header__title page-title">Invoices</h4>
            @if (!isLoading) {
                <div class="ws-section__header__actions">
                    @if (!siteId) {
                        <div class="ws-section__header__actions__item">
                            <label class="m-0 me-1" for="dateRange">RIBS Due Date Range: </label>
                            <weissman-datetime [(inputDate)]="fromDate"
                                               [dateOnly]="true"
                                               [timeZone]="'Central'"
                                               data-qa="invoices-date-from">
                            </weissman-datetime>
                            <span class="mx-2">to</span>
                            <weissman-datetime [(inputDate)]="toDate"
                                               [dateOnly]="true"
                                               [timeZone]="'Central'"
                                               [rangeEnd]="true"
                                               data-qa="invoices-date-to">
                            </weissman-datetime>
                            <button class="ace-btn btn-sm btn-primary ms-3"
                                    (click)="loadPanel()"
                                    data-qa="invoices-refresh">
                                Refresh
                            </button>
                        </div>
                    }
                    <div class="ws-section__header__actions__item">
                        @if (!creatingAdminInvoices && allowEdit && !editLock) {
                            <button class="ace-btn btn-sm btn-secondary" (click)="createAdHocInvoice()"
                                    data-qa="invoices-create-invoice">Create Invoice
                            </button>
                        }
                        @if (siteId && allowEdit && !editLock && parcelsReadyForInvoiceCount) {
                            <button class="ace-btn btn-sm btn-secondary" (click)="createInvoices()"
                                    data-qa="invoices-create-task-invoices">
                                Invoice {{ parcelsReadyForInvoiceCount }} Parcel Invoice Appeal Savings Task(s)
                            </button>
                        }
                        @if (!siteId && allowEdit && !editLock && !creatingAdminInvoices && sitesReadyForInvoiceCount) {
                            <button class="ace-btn btn-sm btn-secondary" (click)="startCreateAdminInvoices()"
                                    data-qa="invoices-create-admin-fee-invoices">Create Site
                                Admin
                                Fee Invoices
                            </button>
                        }
                    </div>
                </div>
            }
        </div>
    </div>
    <div class="d-flex flex-column flex-grow-1 min-height-0 bg-white py-3 px-2 ace-radius">
        @if (isLoading) {
            <ws-ace-loader [hideLabel]="false"></ws-ace-loader>
        } @else {
            @if (creatingAdminInvoices) {
                <div class="d-flex align-items-center justify-content-end mb-2">
                    <div class="me-2">
                        <label class="m-0 me-1" for="annualYear">Annual Year:</label>
                        <select [(ngModel)]="annualYear" id="annualYear" data-qa="invoices-annual-year">
                            @for (item of years; track item; let i = $index) {
                                <option [ngValue]="item" [attr.data-qa]="'invoices-annual-year-' + i">{{ item }}
                                </option>
                            }
                        </select>
                    </div>
                    <button class="ace-btn btn-sm btn-primary" (click)="createAdminInvoices()"
                            data-qa="invoices-create-admin-invoices">Create
                    </button>
                    <button class="ace-btn btn-sm btn-primary btn-danger"
                            (click)="cancelCreateAdminInvoices()"
                            data-qa="invoices-cancel-create-admin-invoices">
                        Cancel
                    </button>
                </div>
            }
            <div class="table-container d-flex flex-grow-1 min-height-0 overflow-auto">
                <div class="w-100">
                    <table class="ace-table table-condensed table-hover w-100">
                        <thead>
                        <tr>
                            <th>RIBS Due Date</th>
                            @if (!siteId && showSiteColumn) {
                                <th>Site</th>
                            }
                            <th>Contract Type</th>
                            <th>Tax Year</th>
                            <th>RIBS Request #</th>
                            <th>Invoice Amt</th>
                            <th>Status</th>
                        </tr>
                        </thead>
                        <tbody>
                            @for (invoice of this.invoices; track invoice; let i = $index) {
                                <tr class="pointer" (click)="rowSelected(invoice)" [attr.data-qa]="'invoices-row-' + i">
                                    @if (!invoice.dueDate) {
                                        <td>
                                            <div></div>
                                        </td>
                                    }
                                    @if (invoice.dueDate) {
                                        <td>
                                            <div>{{ invoice.dueDate | weissmanDateFormat }}</div>
                                        </td>
                                    }
                                    @if (!siteId && showSiteColumn) {
                                        <td>
                                            <div>{{ invoice.siteName }}</div>
                                        </td>
                                    }
                                    <td>
                                        <div>{{ invoice.contractServiceName }}
                                            @if (invoice.contractServiceType === ContractServiceType.Appeal && invoice.isAdHoc) {
                                                <span> (ad hoc)</span>
                                            }</div>
                                    </td>
                                    <td>
                                        <div>{{ invoice.annualYear }}</div>
                                    </td>
                                    <td>
                                        <div>{{ invoice.invoiceNumber ? invoice.invoiceNumber : 'Draft' }}</div>
                                    </td>
                                    <td>
                                        <div>{{ invoice.invoiceAmount | currency:'USD' }}</div>
                                    </td>
                                    <td>
                                        <div>
                                            <a class="clickable"
                                               (click)="launchTaskModal($event, invoice)"
                                               [attr.data-qa]="'invoices-row-task-status-' + i">{{ invoice.taskSummary[0] ? invoice.taskSummary[0].status : '' }}</a>
                                        </div>
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        }
    </div>
</div>
